import { render } from "./CardFiles.vue?vue&type=template&id=d705735c"
import script from "./CardFiles.vue?vue&type=script&lang=js"
export * from "./CardFiles.vue?vue&type=script&lang=js"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AccessIntegrationSite\\access-integration\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__